package kz.dentalcrm.app.data.network.request_model

import kotlinx.serialization.Serializable

@Serializable
data class LoginBody(
    val email: String,
    val password: String
)